import React from 'react';

import { Badge } from '#/components/ui';

const TeamStatusBadge = ({ isOwner, status }) => {
    if (isOwner) {
        return <Badge className='bg-blue50 text-blue600 rounded-2xl text-xs font-medium px-2 py-[2px]'>Owner</Badge>;
    }

    switch (status) {
        case 'JOINED':
            return (
                <Badge className='bg-blueLight50 text-blueLight700 rounded-2xl text-xs font-medium px-2 py-[2px]'>
                    Member
                </Badge>
            );
        case 'INVITED':
            return (
                <Badge className='bg-blueGray50 text-blueGray700 rounded-2xl text-xs font-medium px-2 py-[2px]'>
                    Invited
                </Badge>
            );
        case 'EXPIRED':
            return (
                <Badge className='bg-error50 text-error700 rounded-2xl text-xs font-medium px-2 py-[2px]'>
                    Expired
                </Badge>
            );
        default:
            return null;
    }
};

export { TeamStatusBadge };
